export enum B2BFormat {
    all = 0,
    ecodex,
    scp
}

export enum B2BFormatView {
    Ecodex = 0,
    Scp
}
